// Rollfristående läge: vilka roller använder systemet, och vilka sköts utanför.
import { PROCESS_STEPS, type ProcessStepDef } from "./constants";
import { PROJECT_ROLES, type ProjectRole } from "./roleViews";

export const isProjectRole = (v: unknown): v is ProjectRole =>
  typeof v === "string" && (PROJECT_ROLES as string[]).includes(v);

export const parseRolesInSystem = (raw: unknown): ProjectRole[] => {
  if (!Array.isArray(raw)) return [];
  return raw.filter(isProjectRole);
};

/** Rollerna som äger ett steg (Bas-P/Bas-U räknas som båda). */
export const ownersOf = (step: ProcessStepDef): ProjectRole[] => {
  const owner = String(step.owner);
  if (owner === "Bas-P/Bas-U") return ["Bas-P", "Bas-U"];
  return isProjectRole(owner) ? [owner] : [];
};

/**
 * Steg som ägs av roller utanför systemet – de kan kvitteras av den som
 * arbetar ensam, i stället för att ligga och vänta på en motpart.
 */
export const stepsOutsideSystem = (
  rolesInSystem: ProjectRole[],
  ownRole: ProjectRole
): ProcessStepDef[] => {
  if (rolesInSystem.length === 0) return [];
  const inside = new Set<ProjectRole>([...rolesInSystem, ownRole]);
  return PROCESS_STEPS.filter((s) => {
    const owners = ownersOf(s);
    return owners.length > 0 && owners.every((o) => !inside.has(o));
  });
};

export const rolesOutsideSystem = (
  rolesInSystem: ProjectRole[],
  ownRole: ProjectRole
): ProjectRole[] => {
  if (rolesInSystem.length === 0) return [];
  const inside = new Set<ProjectRole>([...rolesInSystem, ownRole]);
  return PROJECT_ROLES.filter((r) => !inside.has(r));
};
